import { DependencyList, EffectCallback, useEffect } from 'react'

export const useRafEffect = (effect: EffectCallback, deps?: DependencyList) => {
  useEffect(() => {
    let cleanUpHandler: ReturnType<EffectCallback>
    const rafId = requestAnimationFrame(() => {
      cleanUpHandler = effect()
    })
    return () => {
      cancelAnimationFrame(rafId)
      cleanUpHandler?.()
    }
  }, deps)
}
